import { useSelector } from 'react-redux'
import { botMutationsSelector } from '../selectors/selectors'

export function useBotMutations() {
  return useSelector(botMutationsSelector)
}
